var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.chapter.artist) ? _c('div', {
    staticClass: "card artist"
  }, [_c('div', {
    staticClass: "card-image"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": _vm.logotype
    }
  })]), _vm._v(" "), (this.chapter.thumbnail) ? _c('div', {
    staticClass: "card-image hover"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": _vm.thumbnail
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('p', [_vm._v(_vm._s(this.chapter.author) + " on "), _c('strong', [_c('em', [_vm._v(_vm._s(this.chapter.title))]), _vm._v(" (" + _vm._s(this.chapter.year) + ")")])])])]) : _c('div', {
    staticClass: "card text"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(this.chapter.title))]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(this.chapter.author))])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bcce0ae8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TocItem.vue
// module id = V4/v
// module chunks = 0